// state对象内的key 为 namespace，值为初始化数据，更改值通过dispatch出发action进行更改，确保单项数据流
const state = {
  security: {
    a: 123,
    b: {
      id: 111,
      name: 'abc',
    },
  },
  evengMiddleware: {
    eventName: '',
  },
  apiManagement: {
    api: {
      xxx: 'xxx',
    },
  },
};

export default {
  state,
};
